'use client';

import React from 'react';
import { canUseWindow } from '../../../../../../wag-react/common/xenv/core/canUseWindow';
import { Button } from '../../../../../../wag-react/next-components/button';
import { FacebookShareIcon } from '../../../../../../wag-react/next-components/icons';
export const FacebookShareButton = ({
  shareUrl
}) => {
  const facebookOnClickHandler = () => {
    if (canUseWindow && window.FB) {
      window.FB.ui({
        method: 'share',
        href: shareUrl
      });
    }
  };
  return <Button onClick={facebookOnClickHandler} data-sentry-element="Button" data-sentry-component="FacebookShareButton" data-sentry-source-file="index.tsx">
      <FacebookShareIcon data-sentry-element="FacebookShareIcon" data-sentry-source-file="index.tsx" />
    </Button>;
};